import { Notifications, AlertResponse } from "../types/media";
import { reportMessageToSentry } from "@coworker/app/src/hooks/useConfigureSentry";

export function ensureNotificationsIntegrity(
  notifications: Notifications
): void {
  if (!notifications || !Array.isArray(notifications.alerts)) {
    reportMessageToSentry(
      "Notifications: alerts payload is missing or invalid",
      { notifications },
      "error"
    );
    return;
  }

  let lastAlertToReport: AlertResponse | null = null;

  notifications.alerts.forEach((alert) => {
    const parsedEds = Number.parseInt(String(alert.eds), 10);
    alert.eds = Number.isNaN(parsedEds) || parsedEds < 0 ? 0 : parsedEds;

    if (!Array.isArray(alert.edsDates)) {
      alert.edsDates = [];
    }

    if (alert.eds !== alert.edsDates.length) {
      lastAlertToReport = alert;
    }
  });

  if (lastAlertToReport) {
    reportMessageToSentry(
      "Notifications: Eds count does not match length of edsDates",
      { alert: lastAlertToReport },
      "error"
    );
  }
}
